import { createFileRoute } from "@tanstack/react-router";

import { OccasionLanding } from "../components/landing/occasion-landing";
import { seo } from "../lib/head";
import { OCCASION_PAGES } from "../lib/occasion-pages";

export const Route = createFileRoute("/liste-anniversaire")({
  staticData: { ssr: true },
  head: () =>
    seo({
      title: OCCASION_PAGES.birthday.seoTitle,
      description: OCCASION_PAGES.birthday.seoDescription,
      image: OCCASION_PAGES.birthday.ogImage,
    }),
  component: () => <OccasionLanding occasion="birthday" />,
});
